export default __webpack_public_path__ + "static/media/sylfaen.52e6494d.ttf";